// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9QA9c","newExpiryDate":"styles_newExpiryDate__3_vJ-","footer":"styles_footer__22pxW"};